__turbopack_context__.v({
  "avatar": "gTcl0q_avatar",
  "avatar-blink": "gTcl0q_avatar-blink",
  "avatar-breathe": "gTcl0q_avatar-breathe",
  "avatar-cheer": "gTcl0q_avatar-cheer",
  "avatar-droop": "gTcl0q_avatar-droop",
  "avatar-gasp": "gTcl0q_avatar-gasp",
  "avatar-glance": "gTcl0q_avatar-glance",
  "avatar-head": "gTcl0q_avatar-head",
  "avatar-hop": "gTcl0q_avatar-hop",
  "avatar-laugh-body": "gTcl0q_avatar-laugh-body",
  "avatar-laugh-head": "gTcl0q_avatar-laugh-head",
  "avatar-piece-in": "gTcl0q_avatar-piece-in",
  "avatar-tear": "gTcl0q_avatar-tear",
  "body": "gTcl0q_body",
  "brows": "gTcl0q_brows",
  "eyes": "gTcl0q_eyes",
  "gaze": "gTcl0q_gaze",
  "happy": "gTcl0q_happy",
  "head": "gTcl0q_head",
  "hovering": "gTcl0q_hovering",
  "interactive": "gTcl0q_interactive",
  "laugh": "gTcl0q_laugh",
  "lean": "gTcl0q_lean",
  "moves": "gTcl0q_moves",
  "pieceIn": "gTcl0q_pieceIn",
  "pressed": "gTcl0q_pressed",
  "pupil": "gTcl0q_pupil",
  "sad": "gTcl0q_sad",
  "tear": "gTcl0q_tear",
  "wow": "gTcl0q_wow",
});
